/** 抓取網址查詢參數 */
export function getQueryParam(key: string): string | null {
  const urlParams = new URLSearchParams(window.location.search)
  let param = urlParams.get(key)

  if (param) {
    param = decodeURIComponent(param)
    param = param.replace(/ /g, '+')
  }

  return param
}
